<script>

export default {
    formatTime (time, needDay) {
        let day = 0;
        if (needDay) {
            day = Math.floor(time / (60 * 60 * 24));
        }
        let hour = Math.floor(time / (60 * 60) - day * 24).toString().padStart(2, '0');
        let minute = Math.floor(time / 60 - day * 24 * 60 - hour * 60).toString().padStart(2, '0');
        let second = Math.floor( time - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60).toString().padStart(2, '0');
        let tenthOfSecond = Math.floor(time * 10 - day * 24 * 60 * 60 * 10 - hour * 60 * 60 * 10 - minute * 60 * 10 - second * 10).toString();
        return {day, hour, minute, second, tenthOfSecond};
    }
}
</script>


// WEBPACK FOOTER //
// formatTime.vue